module.exports = __webpack_public_path__ + "static/img/img-about-10.b2f7ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-10.png
// module id = Hvsu
// module chunks = 0